<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';
import Inputmask from "inputmask";

const storeField = useFieldsStore();

const value = ref(null);
const inputRef = ref(null);

const { validation, isValid, isTouched, textError } = useValidation(value)

const props = defineProps({    
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    }, 
    required: {
        type: Boolean,
    },   
})

// Функция для применения маски
const applyMask = () => {
    if (inputRef.value) {
        const im = new Inputmask({
            mask: "+7 (999) 999-99-99",
            placeholder: "_",
            clearIncomplete: true,
            showMaskOnHover: false,
            oncomplete: () => validation(props.stateKey),
            onincomplete: () => validation(props.stateKey)
        });
        im.mask(inputRef.value);
    }
};

onMounted(() => {
    nextTick(() => {
        applyMask();
    });
});

watch(
	() => storeField.fields[props.stateKey]?.title,
	(newVal) => {
       
		if (newVal !== value.value) {
			value.value = newVal ?? "";			
		}
	},
	{ immediate: true }
);


const handleInput = (event) => {
    value.value = event.target.value;
    storeField.updateFields(props.stateKey, 'title', value.value);
    validation(props.stateKey);
};
</script>

<template>
    <label :class="['input']">
        <div class="input__holder">
			<span class="input__title"><slot></slot></span>
            <input 
                ref="inputRef"
                type="tel"
                :placeholder="placeholder"
                :required="required"
                :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid') ]"
                @input="handleInput"  
                @blur="validation(stateKey)"
                :value="value"
            >
        </div>
        
        <Transition>
            <span v-if="!!textError" class="input__error">{{ textError }}</span>
        </Transition>
    </label>
</template>
<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
	transition: all 0.25s ease-out;
}

.v-enter-from {
	opacity: 0;
	transform: translate(0%, 10px);
}
.v-leave-to {
	opacity: 0;
	transform: translate(0%, 10px);
}
</style>
